import { render, staticRenderFns } from "./same.vue?vue&type=template&id=55034db6&scoped=true"
import script from "./same.vue?vue&type=script&lang=js"
export * from "./same.vue?vue&type=script&lang=js"
import style0 from "./same.vue?vue&type=style&index=0&id=55034db6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55034db6",
  null
  
)

export default component.exports